/* global API_HOSTNAME:false */
/* global closest:false */
/* global dataLayer:false */
/* global resetAccessibleMessage:false */
/* global setAccessibleMessage:false */
/* global trigger:false */

(function() {
	const prepareResponseOverlayAfterSubmit = function(formElement) {
		formElement.querySelector('.js-newsletter-signup-response').classList.add('overlay-response--show-overlay');
		formElement.querySelector('.js-newsletter-signup-response-messages').focus();
		formElement.setAttribute('data-submitted', true);
	};

	var newsletterSignupForms = document.querySelectorAll('.js-newsletter-signup');
	for (var i = 0 ; i < newsletterSignupForms.length; i++) {
		var newsletterSignupForm = newsletterSignupForms[i];

		newsletterSignupForm.setAttribute('data-submitted', false);

		newsletterSignupForm.addEventListener('formvalid', (ev) => {
			const details = ev.detail;
			const form = details.formElement;
			const isSubmitted = form.getAttribute('data-submitted');

			if (isSubmitted == 'true') {
				return false;
			}

			var submitButton = form.querySelector('.js-submit-button');
			trigger(submitButton, 'progress');

			form.querySelector('.js-newsletter-signup-source-url-field').value = window.location.href;

			var data = {
				'SubscribeIntoNewsletter': {
					'creative': form.querySelector('.js-newsletter-signup-creative-field').value,
					'email': form.querySelector('input[type="text"],input[type="email"]').value,
					'language': 'en',
					'source': 'English website',
					'sourceUrl': window.location.href,
				},
			};

			const handleAlreadySubscribedState = function() {
				var message = form.querySelector('.js-newsletter-signup-response-already-in-list');
				setAccessibleMessage(message);
				message.style.display = '';
			};

			const handleErrorState = function() {
				var message = form.querySelector('.js-newsletter-signup-response-error');
				setAccessibleMessage(message, 'alert');
				message.style.display = '';
			};

			const resetErrorMessages = function() {
				var message = form.querySelector('.js-newsletter-signup-response-error');
				resetAccessibleMessage(message);
				message.style.display = 'none';
			};

			const handlePendingState = function() {
				var message = form.querySelector('.js-newsletter-signup-response-pending');
				setAccessibleMessage(message);
				message.style.display = '';
			};

			const handleSuccessState = function() {
				var message = form.querySelector('.js-newsletter-signup-response-success');
				setAccessibleMessage(message);
				message.style.display = '';
			};

			var request = new XMLHttpRequest();
			request.open('POST', API_HOSTNAME + '/action?action=SubscribeIntoNewsletter', true)
			request.withCredentials = true;
			request.timeout = 30000;
			request.setRequestHeader('Content-Type', 'application/json');

			request.onerror = function() {
				trigger(submitButton, 'active');
				handleErrorState();
			}

			request.onreadystatechange = function() {
				// Request finished. Do processing here.
				if (this.readyState === XMLHttpRequest.DONE) {
					trigger(submitButton, 'active');

					if (this.status === 200) {
						const response = JSON.parse(this.response);

						if (response.status === 'ok') {
							resetErrorMessages();
							var result = response.actions.SubscribeIntoNewsletter.status;

							switch (result) {
								case 'subscribed':
									prepareResponseOverlayAfterSubmit(form);
									handleSuccessState();

									const modal = closest(form, '.js-exit-intent-dialog');
									if (modal) {
										// GA tracking using Google Tag Manager
										dataLayer.push({
											'event': 'gaEvent',
											'eventCategory': 'Exit Intent',
											'eventAction': 'converted',
											'eventLabel': modal.getAttribute('data-ga-label'),
										});
									} else {
										// GA tracking using Google Tag Manager
										dataLayer.push({
											'event': 'gaEvent',
											'eventCategory': 'Newsletter',
											'eventAction': 'subscribed',
											'eventLabel': 'newsletter page',
										});
									}

									break;

								case 'alreadySubscribed':
									prepareResponseOverlayAfterSubmit(form);
									handleAlreadySubscribedState();
									break;

								case 'pending':
									prepareResponseOverlayAfterSubmit(form);
									handlePendingState();
									break;

								default:
									handleErrorState();
									break;
							}
						} else {
							handleErrorState();
						}
					} else {
						handleErrorState();
					}
				}
			}

			request.send(JSON.stringify(data));
		});

		newsletterSignupForm.addEventListener('submit', (ev) => {
			ev.preventDefault();

			return false;
		});
	}
})();
